/**
 * Created by Carsten Bühler
 * User: CBuehler on 01.06.2016
 * Copyright: xdot GmbH 2015
 */

export default {
    openUploadForm(assetEntryIds, tagNames, folderId) {
        return openUploadForm(assetEntryIds, tagNames, folderId);
    }
};

function openUploadForm(assetEntryIds, tagNames, folderId) {
    AUI().use('aui-base', 'escape', 'liferay-search-container', 'liferay-portlet-url', function (A) {


        let renderURL = Liferay.PortletURL.createURL('/group/control_panel'),
            eventName = 'UploadFileEvent_' + new Date().getTime();

        renderURL.setWindowState('pop_up');
        renderURL.setPortletMode('view');
        renderURL.setParameter('eventName', eventName);

        renderURL.setParameter('folderId', folderId);
        renderURL.setParameter('mvcRenderCommandName', '/document_library/edit_file_entry');
        renderURL.setParameter('fliwasAssetEntryIds', (assetEntryIds || []).join());
        renderURL.setParameter('fliwasCommand', 'BusinessObjectUpload');
        renderURL.setParameter('scopeGroupId', Liferay.ThemeDisplay.getScopeGroupId());
        renderURL.setParameter('selectedGroupIds', Liferay.ThemeDisplay.getCompanyGroupId() + ',' + Liferay.ThemeDisplay.getScopeGroupId());
        renderURL.setParameter('fliwasTagNames', (tagNames || []).join());
        renderURL.setParameter('groupId', Liferay.ThemeDisplay.getScopeGroupId());
        renderURL.setPortletId('com_liferay_document_library_web_portlet_DLPortlet');
        renderURL.setDoAsGroupId(Liferay.ThemeDisplay.getScopeGroupId());

        let url = renderURL.toString();
        let id = 'UploadDialog_' + new Date().getTime();
        let dialog;

        window.subscribeEvent('businessObjectUploadSuccessFull', document, function (e) {
            dialog.hide();

        });
        window.eventDocument = document;

        Liferay.Util.openWindow(
            {
                dialog: {
                    constrain: true,
                    modal: true,
                    on: {}
                },

                eventName: eventName,
                id: id,
                title: 'Dokument hochladen',
                uri: url
            }, function (d) {
                dialog = d
            });
    }.bind(this));
}



// WEBPACK FOOTER //
// ./js/utils/uploadFile.js